import { Component, OnDestroy, OnInit } from '@angular/core';
import { PROTOCOL_MORTGAGE } from '../../../product-helper';

import { JointCreditManager } from '../../../types/joint-applicant/joint-credit-manager.class';
import { BuildingBlock, BuildingBlockControlBaseComponent } from '../building-block.types';

// tslint:disable: completed-docs
/**
 * A Building block for joint credit select
 */
@BuildingBlock('joint-credit-select')
@Component({
  selector: 'ecp-joint-credit-select',
  styleUrls: ['./joint-credit-select.component.scss'],
  templateUrl: './joint-credit-select.component.html'
})
export class JointCreditSelectComponent extends BuildingBlockControlBaseComponent implements OnInit, OnDestroy {
  public coBorrowers: JointCreditManager = new JointCreditManager(this.statefulService, PROTOCOL_MORTGAGE);

  /** Angular init function */
  public ngOnInit(): void {
    this.coBorrowers.refreshWhenCoBorrowerChange();
  }

  /** Angular OnDestroy function */
  public ngOnDestroy(): void {
    this.coBorrowers.unsubscribe();
  }

  public trackByFn(index): void {
    return index;
  }
}
